import { render, staticRenderFns } from "./create-product-group.vue?vue&type=template&id=017149f7&scoped=true&"
import script from "./create-product-group.vue?vue&type=script&lang=js&"
export * from "./create-product-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017149f7",
  null
  
)

export default component.exports